import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Droplet,
    Wifi,
    Tent,
    AlertTriangle,
    Sparkles,
    Briefcase,
} from 'lucide-react';
import { S } from './PointCommentFilter.styles';
import { CommentCategory } from 'utils/waypointHelper';
import { FilterViewProps } from './PointCommentFilter.interface';

export const FILTER_STORAGE_KEY = "commentFilter";

type Filter = {
    label: string;
    icon: React.ReactNode;
    value: string;
    bgColor: string;
    bgColorActive: string
    textColor: string;
};

const filters: Filter[] = [
    { label: 'water', icon: <Droplet />, value: CommentCategory.Water, bgColor: '#d3e6fc', bgColorActive: '#1d65d3', textColor: '#1d65d3' },
    { label: 'connectivity', icon: <Wifi />, value: CommentCategory.Connectivity, bgColor: '#ccf0f3', bgColorActive: '#00b1b0', textColor: '#00b1b0' },
    { label: 'camping', icon: <Tent />, value: CommentCategory.Camping, bgColor: '#e5dcd7', bgColorActive: '#5a3b1d', textColor: '#5a3b1d' },
    { label: 'conditions', icon: <AlertTriangle />, value: CommentCategory.Conditions, bgColor: '#ffe2bb', bgColorActive: '#f1921c', textColor: '#f1921c' },
    { label: 'trail_magic', icon: <Sparkles />, value: CommentCategory.TrailMagic, bgColor: '#f0d6fc', bgColorActive: '#b246e4', textColor: '#b246e4' },
    { label: 'lost_found', icon: <Briefcase />, value: CommentCategory.LostNFound, bgColor: '#d4d4d4', bgColorActive: '#444444', textColor: '#444444' },
];

const FilterView: React.FC<FilterViewProps> = ({
  onFilterChanged
}) => {

    const [activeFilters, setActiveFilters] = useState<string[]>([]);

    useEffect(() => {
        // Load from localStorage on first render
        const stored = localStorage.getItem(FILTER_STORAGE_KEY);
        const filters = stored ? JSON.parse(stored) : [];
        setActiveFilters(filters);
    }, [setActiveFilters]);

    // const [activeFilters, setActiveFilters] = useState<string[]>(() => {
    //     // Load from localStorage on first render
    //     const stored = localStorage.getItem(FILTER_STORAGE_KEY);
    //     return stored ? JSON.parse(stored) : [];
    // });

    // useEffect(() => {
    // }, [activeFilters, onFilterChanged]);

    const toggleFilter = (value: string) => {
        const newFilter = activeFilters.includes(value) ? activeFilters.filter((v) => v !== value) : [...activeFilters, value]
        setActiveFilters(newFilter);
        localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(newFilter));
        onFilterChanged();
    };

    return (
        <S.Container>
            {filters.map((filter) => {
              const isActive = activeFilters.includes(filter.value);
              return (
                <S.FilterButton
                  key={filter.value}
                  onClick={() => toggleFilter(filter.value)}
                  $bgColor={filter.bgColor}
                  $bgColorActive={filter.bgColorActive}
                  $textColor={filter.textColor}
                  $active={isActive}
                  aria-pressed={isActive}
                >
                  {filter.icon}
                  <span className="label"><FormattedMessage id={filter.label}/></span>
                </S.FilterButton>
              );
            })}
        </S.Container>
    );
};

export default FilterView;